import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../context/AuthContext";

export default function SignOutConfirm({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSignOut = async () => {
    setLoading(true);
    await logout();
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div className="w-full max-w-xs rounded-xl bg-white p-5 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-base font-semibold text-gray-900 mb-2">{t("signOut.confirmTitle")}</h3>
        <div className="flex gap-2 mt-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 min-h-[44px] rounded-lg border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            {t("common.cancel")}
          </button>
          <button
            type="button"
            onClick={() => void handleSignOut()}
            disabled={loading}
            className="flex-1 min-h-[44px] rounded-lg bg-red-600 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50"
          >
            {loading ? t("common.loading") : t("auth.logout")}
          </button>
        </div>
      </div>
    </div>
  );
}
